import { render, staticRenderFns } from "./HomeResearchBlock.vue?vue&type=template&id=48faa9c1&scoped=true&"
import script from "./HomeResearchBlock.vue?vue&type=script&lang=js&"
export * from "./HomeResearchBlock.vue?vue&type=script&lang=js&"
import style0 from "./HomeResearchBlock.vue?vue&type=style&index=0&id=48faa9c1&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48faa9c1",
  null
  
)

export default component.exports